<template>
  <div class="app-container">
    <el-form
      :model="queryParams"
      ref="queryForm"
      size="small"
      :inline="true"
      label-width="68px"
    >
      <el-form-item label="关键字" prop="keyWord">
        <el-input
          v-model="queryParams.condition.keyWord"
          placeholder="请输入项目名称"
          clearable
          style="width: 240px"
        />
      </el-form-item>
      <el-form-item label="日期" prop="value2">
        <el-date-picker
          v-model="value2"
          type="month"
          value-format="yyyy-MM"
          @change="handleDateChange"
          :picker-options="pickerOptions"
          placeholder="选择月"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-button
          type="primary"
          icon="el-icon-search"
          size="mini"
          @click="handleQuery"
          >搜索</el-button
        >
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery"
          >重置</el-button
        >
      </el-form-item>
      <div class="exportTitem">
        <el-button
          type="button"
          style="margin-right: 10px"
          @click="updateDing()"
          >更新</el-button
        >
        <el-button
          type="button"
          @click="exportExcel(previousMonth + `月份考勤表`)"
          >导出表格</el-button
        >
      </div>
      
    </el-form>
    <el-table
      :data="tableData"
      v-loading="loading"
      style="width: 100%"
      height="calc(100vh - 220px)"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      ref="report-table"
    >
      <el-table-column
        type="index"
        fixed="left"
        align="center"
        label="序号"
        width="50"
      >
      </el-table-column>
      <el-table-column
        prop="deptName"
        fixed="left"
        align="center"
        label="部门"
        width="180"
      >
      </el-table-column>
      <el-table-column
        prop="userName"
        fixed="left"
        align="center"
        label="姓名"
        width="100"
      >
      </el-table-column>
      <el-table-column
        prop="shouldCheckDay"
        align="center"
        label="应到（d）"
        width="150"
      >
      </el-table-column>
      <el-table-column
        prop="actualCheckDay"
        align="center"
        label="实际考勤天数"
        width="150"
      >
      </el-table-column>
      <el-table-column
        prop="loseCheckDay"
        align="center"
        label="缺勤天数"
        width="150"
        :formatter="formatNumber"
      >
      </el-table-column>
      <el-table-column
        prop="missCardTimes"
        align="center"
        label="漏打卡（次）"
        width="150"
      >
      </el-table-column>
      <el-table-column
        prop="lateBackTimes"
        align="center"
        label="迟到/早退（次）"
        width="150"
      >
      </el-table-column>
      <el-table-column
        prop="absentDays"
        align="center"
        label="旷工（天）"
        width="150"
      >
      </el-table-column>
      <el-table-column label="假期" align="center">
        <el-table-column
          prop="addWorkHours"
          align="center"
          label="加班（小时)"
          width="120"
        >
        </el-table-column>
        <el-table-column
          prop="thingHolidayDays"
          align="center"
          label="事假（天)"
          width="120"
        >
        </el-table-column>
        <el-table-column
          prop="convertRelaxHours"
          align="center"
          label="调休（小时）"
          width="120"
        >
        </el-table-column>
        <el-table-column
          prop="illnessHolidayDays"
          align="center"
          label="病假（天）"
          width="120"
        >
        </el-table-column>
        <el-table-column
          prop="yearHolidayDays"
          align="center"
          label="年假（天）"
          width="120"
        >
        </el-table-column>
        <el-table-column
          prop="marryHolidayDays"
          align="center"
          label="婚假（天）"
          width="120"
        >
        </el-table-column>
        <el-table-column
          prop="dieHolidayDays"
          align="center"
          label="丧假（天）"
          width="120"
        >
        </el-table-column>
        <el-table-column
          prop="growHolidayDays"
          align="center"
          label="产假（天）"
          width="120"
        >
        </el-table-column>
        <el-table-column
          prop="accompanyGrowHolidayDays"
          align="center"
          label="陪产假（天）"
          width="120"
        >
        </el-table-column>
        <el-table-column
          prop="outWorkDays"
          align="center"
          label="出差（天）"
          width="120"
        >
        </el-table-column>
      </el-table-column>
      <el-table-column prop="remarks" align="center" label="备注" width="300">
        <template slot-scope="scope">
          <div v-html="scope.row.remarks"></div>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="queryParams.page"
      :limit.sync="queryParams.limit"
      :pageSizes="[100, 150, 200, 500]"
      @pagination="getList"
    />
  </div>
</template>

<script>
import { getDingCheck, updateDing } from "@/api/ding/DingList";
import moment from "moment";
import FileSaver from "file-saver";
import XLSXStyle from "xlsx-style";
import * as XLSX from "xlsx";

export default {
  data() {
    return {
      tableData: [],
      currentYear: new Date().getFullYear(),
      currentMonth: new Date().getMonth() + 1, // JavaScript 中月份是从0开始的
      previousYear: 0,
      previousMonth: 0,
      queryParams: {
        condition: {
          keyWord: "",
          year: "",
          month: "",
        },
        limit: 100,
        page: 1,
        orders: [
          {
            asc: true,
            column: "createTime",
          },
        ],
      },
      value2: "",
      total: 0,
      currentDate: new Date(),
      loading: false,
      pickerOptions: {
        disabledDate: (time) => {
          let max = moment(`${this.previousYear}-${this.previousMonth}`).unix();
          time = time.getTime() / 1000;
          return time > max;
        },
      },
    };
  },
  async created() {
    this.calculatePreviousYearMonth();
    this.getList();
  },
  methods: {
    /** 更新列表 */
    updateDing() {
      this.loading = true;
      updateDing().then((res) => {
        if (res.code === 200) {
          this.$message({
            message: "更新成功",
            type: "success",
          });
          this.loading = false;
          this.queryParams.page = 1;
          this.getList();
        } else {
          this.$message({
            message: res.msg || "更新失败",
            type: "error",
          });
          this.loading = false;
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    formatNumber(row, column, cellValue) {
      // 使用 toFixed(2) 保留2位小数
      // 如果 cellValue 不是数字，先转换为数字
      const num = Number(cellValue) || 0;
      return num.toFixed(2);
    },
    /** 查询用户列表 */
    async getList() {
      this.loading = true;
      let { data } = await getDingCheck(this.queryParams);
      this.tableData = data.records;
      this.total = data.total;
      //获取项目
      this.loading = false;
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParams.page = 1; // 重置：回到第 1 页
      this.queryParams.condition.keyWord = undefined;
      this.getList();
    },
    calculatePreviousYearMonth() {
      let year = this.currentYear;
      let month = this.currentMonth;
      if (month === 1) {
        year -= 1;
        month = 12;
      } else {
        month -= 1;
      }
      this.previousYear = year;
      this.previousMonth = month;
      this.value2 = `${year}-${month}`;
      this.queryParams.condition.year = year;
      this.queryParams.condition.month = month;
    },
    /**
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.page = 1;
      this.getList();
    },
    handleDateChange(val) {
      this.queryParams.page = 1; // 日期筛选：回到第 1 页
      if (val == null) return; //
      let s = val.split("-");
      this.queryParams.condition.year = s[0];
      this.queryParams.condition.month = s[1];
      this.getList();
    },
    handleSizeChange(val) {
      this.queryParams.limit = val;
      this.getList();
    },

    exportExcel(excelName) {
      try {
        const $e = this.$refs["report-table"].$el;
        let $table = $e.querySelector(".el-table__fixed");
        if (!$table) {
          $table = $e;
        }
        const wb = XLSX.utils.table_to_book($table, { raw: true });

        this.setWbExlStyle(wb["Sheets"]["Sheet1"]);
        const wbout = XLSXStyle.write(wb, {
          bookType: "xlsx",
          bookSST: true,
          type: "buffer",
        });
        FileSaver.saveAs(
          new Blob([wbout], { type: "application/octet-stream" }),
          `${excelName}.xlsx`
        );
      } catch (e) {
        if (typeof console !== "undefined") console.error(e);
      }
    },
    setWbExlStyle(data) {
      data["!cols"] = [];
      const col = [
        "A1",
        "B1",
        "C1",
        "D1",
        "E1",
        "F1",
        "G1",
        "H1",
        "I1",
        "J1",
        "K1",
        "L1",
        "M1",
        "N1",
        "O1",
        "P1",
        "Q1",
        "R1",
        "S1",
        "T1",
        "J2",
        "K2",
        "L2",
        "M2",
        "N2",
        "O2",
        "P2",
        "Q2",
        "R2",
        "S2",
      ];

      const defaultStyle = {
        alignment: {
          horizontal: "center",
          vertical: "center",
          wrapText: true,
        },
        font: {
          sz: 12,
          name: "宋体",
        },
        border: {
          top: { style: "thin", color: { auto: 1 } },
          left: { style: "thin", color: { auto: 1 } },
          right: { style: "thin", color: { auto: 1 } },
          bottom: { style: "thin", color: { auto: 1 } },
        },
      };

      const headerStyle = {
        ...defaultStyle,
        font: { ...defaultStyle.font, bold: true, color: { rgb: "FFFFFF" } },
        fill: { fgColor: { rgb: "2D529F" } },
      };

      const cellStyle = {
        ...defaultStyle,
        font: { ...defaultStyle.font, bold: false },
      };

      for (let key in data) {
        if (data[key] instanceof Object) {
          data[key].s = col.includes(key) ? headerStyle : cellStyle;

          // 根据需求设置列宽
          const colIndex = col.indexOf(key);
          if (colIndex === -1) continue;

          const width = [
            100, 150, 120, 120, 120, 120, 120, 120, 120, 120, 120, 120, 120,
            120, 120, 120, 120, 120, 120, 260,
          ];
          data["!cols"][colIndex] = { wpx: width[colIndex] };
        }
      }

      return data;
    },
  },
};
</script>
<style lang="scss" scoped>
.exportTitem {
  float: right;
}
</style>
